"use strict";

var RoutePath = require('../constants/routePath');
var ModulePath = require('../constants/modulePath');
var moduleCodes = require('../constants/moduleCodes');
var adminPath = ModulePath[moduleCodes.MODULE_ADMIN];

var RouterUtility = require('../utils/routerUtility');

/**
 * Wrapper for ADMIN routes
 * @type {{getOrganisations: AdminRouteWrapper.getOrganisations, getAdmin: AdminRouteWrapper.getAdmin, _getFullRoutePath: AdminRouteWrapper._getFullRoutePath}}
 */
var AdminRouteWrapper = {
  getOrganisations: function () {
    return this._getFullRoutePath(RoutePath.ROUTE_ADMIN_ORGANISATIONS);
  },

  getAdmin: function () {
    return '/' + adminPath;
  },

  _getFullRoutePath: function (routePath) {
    var fullRoutePath = RouterUtility.getRoutePath(adminPath, routePath);
    return fullRoutePath;
  },
};
module.exports = AdminRouteWrapper;
